import React from 'react'
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
} from './SidebarElements'

const Sidebar = ({ isOpen, toggle }) => {
    const handleClick = (e, id) => {
        e.preventDefault();
        toggle();
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink
                        href="/#work"
                        onClick={(e) => handleClick(e, 'work')}
                    >
                        Our Work
                    </SidebarLink>
                    <SidebarLink
                        href="/#clients"
                        onClick={(e) => handleClick(e, 'clients')}
                    >
                        Our Clients
                    </SidebarLink>
                    <SidebarLink
                        href="/#about"
                        onClick={(e) => handleClick(e, 'about')}
                    >
                        About Us
                    </SidebarLink>
                    <SidebarLink
                        href="/#contact"
                        onClick={(e) => handleClick(e, 'contact')}
                    >
                        Contact Us
                    </SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar 